import { useAuth0 } from '../../auth';
import { AnonymousMenu } from './components/anonymous-menu/anonymous-menu';
import { AuthenticatedMenu } from './components/authenticated-menu/authenticated-menu';

export const AuthMenu = () => {
  const { isAuthenticated } = useAuth0();
  return isAuthenticated ? <AuthenticatedMenu /> : <AnonymousMenu />;
};
